import { TransactionType } from '@shared/helpers/enums/transaction-type';
import { SecurityMode } from '../helpers/security-mode';

export class UpsertSecurityState {
  mode!: SecurityMode;
  transactionType!: TransactionType;
  securityId!: number;

  constructor(transactionType: string, securityId: string) {
    this.transactionType = parseInt(transactionType, 10) as TransactionType;
    this.securityId = Number(securityId);

    if (this.transactionType === TransactionType.GeneralRates && !securityId) {
      this.mode = SecurityMode.AddGeneralRates;
    } else if (
      this.transactionType === TransactionType.GeneralRates &&
      securityId
    ) {
      this.mode = SecurityMode.UpdateGeneralRates;
    } else if (
      securityId &&
      this.transactionType === TransactionType.SpecificAdvice
    ) {
      this.mode = SecurityMode.UpdateSpecificAdvice;
    } else {
      this.mode = SecurityMode.AddSpecificAdvice;
    }
  }

  get isAddSpecificAdvice(): boolean {
    return this.mode === SecurityMode.AddSpecificAdvice;
  }

  get isUpdateSpecificAdvice(): boolean {
    return this.mode === SecurityMode.UpdateSpecificAdvice;
  }

  get isAddGeneralRates(): boolean {
    return this.mode === SecurityMode.AddGeneralRates;
  }

  get isUpdateGeneralRates(): boolean {
    return this.mode === SecurityMode.UpdateGeneralRates;
  }

  get isSpecificAdviceTransaction(): boolean {
    return this.transactionType === TransactionType.SpecificAdvice;
  }

  get isGeneralRatesTransaction(): boolean {
    return this.transactionType === TransactionType.GeneralRates;
  }
}
